import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import * as TakeOutOrderStore from './TakeOutOrderStore';
import { Command } from 'pos/common';
import { Permission } from 'core/api';

declare global {
	interface CommandType {
		markTakeOutOrderAsDelivered: (orderId: number) => Promise<Result>
	}
}

Command.register('markTakeOutOrderAsDelivered', Preconditions.and(Preconditions.ensure(Permission.SalesOrder_MarkAsDelivered), Preconditions.ensureIsNotLite), async (orderId: number): Promise<Result> => {
	await TakeOutOrderStore.markAsDelivered(orderId);
	return Result.ok();
});
